import React, { useState } from 'react';
import { RoomBuilder } from './components/RoomBuilder';
import { KitchenBuilder } from './components/KitchenBuilder';
import { AppHeader } from './components/AppHeader';
import { ThemeProvider } from './components/ThemeProvider';
export function App() {
  const [currentScreen, setCurrentScreen] = useState('room'); // 'room' or 'kitchen'
  const [roomData, setRoomData] = useState(null);
  const handleRoomComplete = data => {
    setRoomData(data);
    setCurrentScreen('kitchen');
  };
  const goBack = () => {
    setCurrentScreen('room');
  };
  return <ThemeProvider data-id="element-0">
      <div className="flex flex-col h-screen bg-gray-50 dark:bg-darkbg-primary dark:text-white" data-id="element-1">
        <AppHeader currentScreen={currentScreen} onBack={currentScreen === 'kitchen' ? goBack : undefined} data-id="element-2" />
        <main className="flex-1 overflow-hidden" data-id="element-3">
          {currentScreen === 'room' && <RoomBuilder onComplete={handleRoomComplete} data-id="element-4" />}
          {currentScreen === 'kitchen' && <KitchenBuilder roomData={roomData} data-id="element-5" />}
        </main>
      </div>
    </ThemeProvider>;
}